import React from 'react';
import './About.css';


const About = () => {
  return (
    <div className="about-section">
      <div className="about-content">
        <div className="logo-container">
          <img src={require("../assets/phplogo.png")} alt="PHP Logo" className="php-logo" />
        </div>
        <h1 className="welcome-header">
          Welcome to Purple Hippo Printing
        </h1>
        <div className="about-description">
          <p>
            We're passionate about bringing your ideas to life through high-quality custom printing. 
            With years of experience in the industry, we specialize in creating perfect custom apparel 
            for individuals, teams, and businesses.
          </p>
          <p>
            Our printing technology and attention to detail ensure that every 
            product meets our high standards of quality. Whether you need one shirt or a hundred, 
            we're here to help make your vision a reality.
          </p>
        </div>
        <div className="about-features">
          <div className="feature">
            <h3>Quality Guaranteed</h3>
            <p>Premium materials and expert printing techniques</p>
          </div>
          <div className="feature">
            <h3>Custom Designs</h3>
            <p>Bring your unique ideas to life</p>
          </div>
          <div className="feature">
            <h3>Fast Turnaround</h3>
            <p>Quick production and shipping times</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 